//====================================================
//  Function: Slider
//====================================================
function fn_components_slider(){
	// fn_detail_slider();
	fn_main_slider();
	fn_classic_slider();
	fn_team_slider();
}

function fn_main_slider(){

	var autoplaySpeed = 3000;

	if ($( '.js-slider-hero-image' ).length) {
		$( '.js-slider-hero-image' ).slick({
			infinite: true,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: true,
			pauseOnHover: false,
			pauseOnFocus: false,
			autoplaySpeed: autoplaySpeed,
			cssEase: 'linear',
			asNavFor: '.js-slider-hero-text',
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows style-mobile slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows style-mobile slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			mobileFirst: true
		});

		$( '.js-slider-hero-text' ).slick({
			infinite: true,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: autoplaySpeed,
			cssEase: 'linear',
			pauseOnHover: false,
			pauseOnFocus: false,
			fade: true,
			asNavFor: '.js-slider-hero-image',
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows style-mobile slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows style-mobile slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			mobileFirst: true
		});

		var slickDots = $( '.slick-dots' );
		var slickDotsItem = $( '.slick-dots li' );
		
		var slickDotsActive = $( '.slick-dots .slick-active' );
		slickDotsItem.removeClass( 'is-animated' );
		slickDotsActive.addClass( 'is-animated' );

		$('.js-slider-hero-image').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			slickDotsItem.removeClass( 'is-animated' );
		});
		$('.js-slider-hero-image').on('afterChange', function(event, slick, currentSlide, nextSlide){
			var slickDotsActive = $( '.slick-dots .slick-active' );
			slickDotsItem.removeClass( 'is-animated' );
			slickDotsActive.addClass( 'is-animated' );
		});

	}
}

function fn_classic_slider(){
	if ($( '.js-slider-classic' ).length) {
		$( '.js-slider-classic' ).slick({
			infinite: true,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			variableWidth: false,
			nextArrow: '<span class="slick-arrows style-mobile slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows style-mobile slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			mobileFirst: true
		});
	}
}

function fn_team_slider(){
	if ($( '.js-slider-team' ).length) {
		$( '.js-slider-team' ).slick({
			infinite: false,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 3000,
			cssEase: 'linear',
			speed: 500,
			variableWidth: true,
			centerMode: true,
			nextArrow: '<span class="slick-arrows style-mobile slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
			prevArrow: '<span class="slick-arrows style-mobile slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
			mobileFirst: true
		});
	}
}

// function fn_detail_slider(){
// 	if ($( '.js-slider-main-product' ).length) {
// 		$( '.js-slider-main-product' ).slick({
// 			infinite: true,
// 			dots: false,
// 			slidesToShow:1,
// 			slidesToScroll: 1,
// 			autoplay: false,
// 			arrows: true,
// 			autoplaySpeed: 2000,
// 			cssEase: 'linear',
// 			speed: 500,
// 			fade: true,
// 			nextArrow: '<span class="slick-arrows style-mobile slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
// 			prevArrow: '<span class="slick-arrows style-mobile slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
// 			variableWidth: false,
// 			mobileFirst: true,
// 			asNavFor:  '.js-slider-thumbnail-product' 
// 		});
// 	}

// 	if ($( '.js-slider-thumbnail-product' ).length) {
// 		$( '.js-slider-thumbnail-product' ).slick({
// 			infinite: true,
// 			dots: false,
// 			slidesToShow: 3,
// 			slidesToScroll: 1,
// 			arrows: false,
// 			autoplay: false,
// 			centerMode: true,
// 			autoplaySpeed: 2000,
// 			cssEase: 'linear',
// 			speed: 500,
// 			asNavFor: '.js-slider-main-product' ,
// 			focusOnSelect: true,
// 			vertical: true,
// 			nextArrow: '<span class="slick-arrows style-1 slick-next"><i class="icon icon-chevron-thin-down"></i></span>',
// 			prevArrow: '<span class="slick-arrows style-1 slick-prev"><i class="icon icon-chevron-thin-up"></i></span>',
// 			verticalSwiping: true
// 		});
// 	}
// }

